export const type = {
    SHOW_C2C_MODAL: "SHOW_C2C_MODAL",
    HIDE_C2C_MODAL: "HIDE_C2C_MODAL",
    C2C_CALL_INITIATED: "C2C_CALL_INITIATED",
    C2C_CALL_SUCCESS: "C2C_CALL_SUCCESS",
    C2C_CALL_FAILED: "C2C_CALL_FAILED",
    C2C_GLOBAL_OPTION_SUCCESS: "C2C_GLOBAL_OPTION_SUCCESS",
    C2C_GLOBAL_OPTION_FAILED: "C2C_GLOBAL_OPTION_FAILED",
}

